import { TransitionType } from "@/components/layout/layoutType";
import { getStringArr } from "./arrayutil";
import { DataInputParams } from "@/components/layout/input/inputType";
import { Debug } from "./debug";
import { checkEmpty } from "./stringutil";
import { Collapse, CollapseProps } from "antd";

export const getDataKeyName = (keys?: string | string[], joinStr?: string): string | undefined => {
  if (keys instanceof Array) {
    return keys?.join(joinStr ?? "_");
  } else {
    return keys;
  }
};
export const getDataKeyValue = (values: any, keys?: string | string[], joinStr?: string): any => {
  if (keys instanceof Array) {
    return keys.map((key) => values[key + ""]).join(joinStr ?? "|");
  } else {
    if (keys) {
      return values[keys + ""];
    } else {
      return undefined;
    }
  }
};
export const getDataKeyList = (params: DataInputParams, joinStr?: string): string[] | undefined => {
  const checkKeys = params.indexKey ? getStringArr(params.indexKey) : undefined;
  if (params.inputMode === "view") {
    if (params.values) {
      Debug(checkKeys);
      return [getDataKeyValue(params.values, checkKeys, joinStr ?? "|")];
    } else {
      return undefined;
    }
  } else {
    if (params.values instanceof Array) {
      return params.values.map((value) => getDataKeyValue(value, checkKeys, joinStr ?? "|"));
    } else {
      if (checkKeys) {
        const keyValues = params.form?.getFieldsValue(checkKeys);
        return [getDataKeyValue(keyValues, checkKeys, joinStr ?? "|")];
      } else {
        return undefined;
      }
    }
  }
};

// export const getDataKeyList = (values: any, keys?: string | string[], joinStr?: string): string[] | undefined => {
//   if (values instanceof Array) {
//     return values.map((value) => getDataKeyValue(value, keys, joinStr ?? "|"));
//   } else {
//     if (values) {
//       return [getDataKeyValue(values, keys, joinStr ?? "|")];
//     } else {
//       return undefined;
//     }
//   }
// };
export const getDataKeyLabel = (params: DataInputParams, joinStr?: string): Record<string, string> | undefined => {
  const result: Record<string, string> = {};
  const checkKeys = params.indexKey ? getStringArr(params.indexKey) : undefined;
  const checkLabelKeys = params.indexLabelKey ? getStringArr(params.indexLabelKey) : undefined;

  if (params.values instanceof Array) {
    params.values.forEach((value) => {
      const key = getDataKeyValue(value, checkKeys, joinStr ?? "|");
      const label = getDataKeyValue(value, checkLabelKeys ?? checkKeys, joinStr ?? " ");
      result[key + ""] = label + "";
    });
  } else {
    if (params.inputMode === "view") {
      if (params.values) {
        const key = getDataKeyValue(params.values, checkKeys, joinStr ?? "|");
        const label = getDataKeyValue(params.values, checkLabelKeys ?? checkKeys, joinStr ?? " ");

        if (key && label) {
          result[key + ""] = label + "";
        }
      }
    } else {
      if (params.form && checkKeys) {
        const keyValues = params.form?.getFieldsValue(checkKeys);
        const LabelValues = params.form?.getFieldsValue(checkLabelKeys ?? checkKeys);
        const key = getDataKeyValue(keyValues, checkKeys, joinStr ?? "|");
        const label = getDataKeyValue(LabelValues, checkLabelKeys ?? checkKeys, joinStr ?? " ");
        Debug(checkKeys, checkLabelKeys, keyValues, LabelValues, key, label);

        if (key && label) {
          result[key + ""] = label + "";
        }
      }
    }
  }
  if (Object.keys(result).length > 0) {
    return result;
  } else {
    return undefined;
  }
};
export const getDataStatusText = (status?: string) => {
  switch (status ?? "403") {
    case "401":
      return "noauth_text";
    case "403":
      return "nopermission_text";
    case "404":
      return "nopage_text";
    default:
      return "nodata_text";
  }
};

export const getNoData = (nodata: string, data: any) => {
  const result_el =
    typeof data.result === "string"
      ? data.result
          .split(/\r\n|\n/)
          .map((item: string, index: number) => {
            return item.trim() === "" ? undefined : (
              <p className="text-justify" key={index}>
                {item}
              </p>
            );
          })
          .filter((item: string | undefined) => item !== undefined)
      : data.result?.localizedMessage ?? data.result?.cause?.localizedMessage;
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: nodata,
      children: result_el,
    },
  ];
  return checkEmpty(result_el) ? nodata : <Collapse items={items} />;
};
